import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  useTheme
} from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import React from 'react'
import { ContractAddButtonOptions } from '../../../pages/clients/file/components/contractsCard/contractsCard.types'
import { ComponentAddButtonOptions } from '../../../pages/priceComponents/add/priceComponentsAdd'
import { styles } from './splitButton.styles'

export interface SplitButtonProps {
  options: ButtonOption[]
  onClick: (option: ButtonOption) => void
  hasPermission?: boolean
  disabled?: boolean
  disabledOptions?: number[]
}

export type ButtonOption = {
  name: ContractAddButtonOptions | ComponentAddButtonOptions | string
  label: string
  id: number
}

export const SplitButton: React.FC<SplitButtonProps> = ({
  options,
  onClick,
  hasPermission = true,
  disabled = false,
  disabledOptions = []
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [selectedIndex, setSelectedIndex] = React.useState(0)

  const handleClick = () => {
    const selectedOption = options[selectedIndex]
    setOpen(false)
    onClick(selectedOption)
  }

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index)
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  if (!hasPermission) {
    return null
  }

  return (
    <>
      <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
        <Button onClick={handleClick} size="small" disabled={disabled}>
          {options[selectedIndex].label}
        </Button>
        <Button
          color="primary"
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          disabled={disabled}
          onClick={handleToggle}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 1000 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {options.map((option, index) => (
                    <MenuItem
                      key={`${option.name}-${option.id}`}
                      disabled={disabledOptions && disabledOptions.includes(index)}
                      selected={index === selectedIndex}
                      onClick={event => {
                        onClick(options[index])
                        setOpen(false)
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
